"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var ListingList_1 = require("./ListingList");
var ListingStoreFront_styles_1 = require("./ListingStoreFront.styles");
var ListingStoreFront_classNames_1 = require("./ListingStoreFront.classNames");
var SearchBox_1 = require("office-ui-fabric-react/lib/SearchBox");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var StringUtils_1 = require("@twii/core/lib/StringUtils");
var ListingStoreFrontTile_1 = require("./ListingStoreFrontTile");
var ListingStoreFrontSection = /** @class */ (function (_super) {
    __extends(ListingStoreFrontSection, _super);
    function ListingStoreFrontSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingStoreFrontSection.prototype.render = function () {
        var classNames = ListingStoreFront_classNames_1.getClassNames(ListingStoreFront_styles_1.getStyles(undefined));
        return (React.createElement("div", { className: classNames.section },
            React.createElement("div", { className: classNames.sectionHeader },
                React.createElement("div", { className: classNames.sectionTitle }, this.props.title)),
            React.createElement("div", { className: classNames.sectionBody }, this.props.children)));
    };
    ListingStoreFrontSection = __decorate([
        mobx_react_1.observer
    ], ListingStoreFrontSection);
    return ListingStoreFrontSection;
}(React.Component));
var ListingStoreFrontListSection = /** @class */ (function (_super) {
    __extends(ListingStoreFrontListSection, _super);
    function ListingStoreFrontListSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderItem = function (listing, idx, props) {
            return React.createElement(ListingStoreFrontTile_1.ListingStoreFrontTile, { key: listing.id, listing: listing, onClick: props.onSelectItem, onLoad: _this.props.onLoad, onOpen: _this.props.onOpen });
        };
        _this._onRenderDone = function () {
            var list = _this.props.storeFront.value ? _this.props.storeFront.value[_this.props.listKey] : undefined;
            if (list && list.length > 0) {
                return React.createElement(ListingList_1.ListingList, { compact: true, wrapping: true, listings: list, onSelectItem: _this.props.onSelectItem, onRenderListing: _this._onRenderItem });
            }
            return React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info },
                "No ",
                _this.props.title,
                " Listings available");
        };
        return _this;
    }
    ListingStoreFrontListSection.prototype.render = function () {
        return (React.createElement(ListingStoreFrontSection, { title: this.props.title },
            React.createElement(Sync_1.Sync, { sync: this.props.storeFront.sync, onRenderDone: this._onRenderDone, syncLabel: "Loading " + this.props.title + " Listings..." })));
    };
    return ListingStoreFrontListSection;
}(React.Component));
var ListingStoreFrontFeaturedSection = /** @class */ (function (_super) {
    __extends(ListingStoreFrontFeaturedSection, _super);
    function ListingStoreFrontFeaturedSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingStoreFrontFeaturedSection.prototype.render = function () {
        return (React.createElement(ListingStoreFrontListSection, __assign({}, this.props, { listKey: "featured", title: "Featured" })));
    };
    return ListingStoreFrontFeaturedSection;
}(React.Component));
var ListingStoreFrontMostPopularSection = /** @class */ (function (_super) {
    __extends(ListingStoreFrontMostPopularSection, _super);
    function ListingStoreFrontMostPopularSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingStoreFrontMostPopularSection.prototype.render = function () {
        return (React.createElement(ListingStoreFrontListSection, __assign({}, this.props, { listKey: "most_popular", title: "Most Popular" })));
    };
    return ListingStoreFrontMostPopularSection;
}(React.Component));
var ListingStoreFrontRecommendedSection = /** @class */ (function (_super) {
    __extends(ListingStoreFrontRecommendedSection, _super);
    function ListingStoreFrontRecommendedSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingStoreFrontRecommendedSection.prototype.render = function () {
        return (React.createElement(ListingStoreFrontListSection, __assign({}, this.props, { listKey: "recommended", title: "Recommended" })));
    };
    return ListingStoreFrontRecommendedSection;
}(React.Component));
var ListingStoreFrontRecentSection = /** @class */ (function (_super) {
    __extends(ListingStoreFrontRecentSection, _super);
    function ListingStoreFrontRecentSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingStoreFrontRecentSection.prototype.render = function () {
        return (React.createElement(ListingStoreFrontListSection, __assign({}, this.props, { listKey: "recent", title: "Recent" })));
    };
    return ListingStoreFrontRecentSection;
}(React.Component));
var ListingStoreFrontSearchInput = /** @class */ (function (_super) {
    __extends(ListingStoreFrontSearchInput, _super);
    function ListingStoreFrontSearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSearchChange = function (newValue) {
            _this.props.storeFront.setSearchText(newValue);
        };
        return _this;
    }
    ListingStoreFrontSearchInput.prototype.render = function () {
        return React.createElement(SearchBox_1.SearchBox, { value: this.props.storeFront.searchText, placeholder: "Search Store", onChange: this._onSearchChange });
    };
    ListingStoreFrontSearchInput = __decorate([
        mobx_react_1.observer
    ], ListingStoreFrontSearchInput);
    return ListingStoreFrontSearchInput;
}(React.Component));
var ListingStoreFrontSearchResultsSection = /** @class */ (function (_super) {
    __extends(ListingStoreFrontSearchResultsSection, _super);
    function ListingStoreFrontSearchResultsSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderItem = function (listing, idx, props) {
            return React.createElement(ListingStoreFrontTile_1.ListingStoreFrontTile, { key: listing.id, listing: listing, onClick: props.onSelectItem, onLoad: _this.props.onLoad, onOpen: _this.props.onOpen });
        };
        _this._onRenderDone = function () {
            if (_this.props.storeFront.searchResults && _this.props.storeFront.searchResults.length > 0) {
                return React.createElement(ListingList_1.ListingList, { listings: _this.props.storeFront.searchResults, compact: true, wrapping: true, onSelectItem: _this.props.onSelectItem, onRenderListing: _this._onRenderItem });
            }
            return React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info }, "No matching listings found");
        };
        return _this;
    }
    ListingStoreFrontSearchResultsSection.prototype.render = function () {
        if (StringUtils_1.isNotBlank(this.props.storeFront.searchText)) {
            return (React.createElement(ListingStoreFrontSection, { title: React.createElement("span", null,
                    "Listings matching ",
                    React.createElement("strong", null, this.props.storeFront.searchText)) },
                React.createElement(Sync_1.Sync, { sync: this.props.storeFront.searchSync, onRenderDone: this._onRenderDone, syncLabel: "Searching Listings..." })));
        }
        return null;
    };
    ListingStoreFrontSearchResultsSection = __decorate([
        mobx_react_1.observer
    ], ListingStoreFrontSearchResultsSection);
    return ListingStoreFrontSearchResultsSection;
}(React.Component));
var ListingStoreFront = /** @class */ (function (_super) {
    __extends(ListingStoreFront, _super);
    function ListingStoreFront() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClickAdd = function () {
            _this.props.onAdd();
        };
        return _this;
    }
    ListingStoreFront.prototype.render = function () {
        var styles = ListingStoreFront_styles_1.getStyles(undefined, this.props.styles);
        var classNames = ListingStoreFront_classNames_1.getClassNames(styles);
        return (React.createElement("div", { className: classNames.root },
            React.createElement("div", { className: classNames.header },
                React.createElement("div", { className: classNames.searchInputContainer },
                    React.createElement(ListingStoreFrontSearchInput, __assign({}, this.props)))),
            React.createElement("div", { className: classNames.body },
                React.createElement(ListingStoreFrontSearchResultsSection, __assign({}, this.props)),
                React.createElement(ListingStoreFrontFeaturedSection, __assign({}, this.props)),
                React.createElement(ListingStoreFrontMostPopularSection, __assign({}, this.props)),
                React.createElement(ListingStoreFrontRecommendedSection, __assign({}, this.props)),
                React.createElement(ListingStoreFrontRecentSection, __assign({}, this.props)))));
    };
    return ListingStoreFront;
}(React.Component));
exports.ListingStoreFront = ListingStoreFront;
var ListingStoreFrontContainer = /** @class */ (function (_super) {
    __extends(ListingStoreFrontContainer, _super);
    function ListingStoreFrontContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingStoreFrontContainer.prototype.componentWillMount = function () {
        this.props.storeFront.load();
    };
    ListingStoreFrontContainer.prototype.render = function () {
        return React.createElement(ListingStoreFront, __assign({}, this.props));
    };
    return ListingStoreFrontContainer;
}(React.Component));
exports.ListingStoreFrontContainer = ListingStoreFrontContainer;
